import { render, staticRenderFns } from "./FavoriteCourses.vue?vue&type=template&id=53d870c5&scoped=true&"
import script from "./FavoriteCourses.vue?vue&type=script&lang=ts&"
export * from "./FavoriteCourses.vue?vue&type=script&lang=ts&"
import style0 from "./FavoriteCourses.vue?vue&type=style&index=0&id=53d870c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d870c5",
  null
  
)

export default component.exports